import { useTranslation } from '@dukanti/shared';
import { RedirectIfAuthed } from '@/components/auth/redirect-if-authed';
import { AuthLayout } from './auth-layout';
import { SigninForm } from './signin-form';

export function SigninRoute() {
  const { t } = useTranslation();
  return (
    <RedirectIfAuthed>
      <AuthLayout
        title={t('admin.signIn.title')}
        subtitle={t('admin.signIn.subtitle')}
        testId="signin-route"
      >
        <SigninForm />
      </AuthLayout>
    </RedirectIfAuthed>
  );
}
